<template>
  <div :id="link.id" class="link-container" :class="{ show: show }">
    <div class="link-time">
      <timesince
        :timestamp="link.createdAt"
      />
    </div>

    <div class="link-wrapper" @click="open">
      <div class="link-image" v-if="link.imageUrl">
        <img :src="processMediaURL(link.imageUrl)"/>
      </div>
      <div class="link-title">{{ link.title }}</div>
      <div class="link-description" v-if="link.description">
        {{ link.description }}
      </div>
      <div class="link-bottom-bar" @click.stop>
        <div class="link-views">
          <img src="@/assets/global-icons/eye-show-small-grey.png" />
          <span>{{ link.clicks }}</span>
        </div>
        <div class="link-options" v-if="userType > 0">
          <div class="link-remove" @click="confirmRemoveLink(link.id)">
            <span>Remove</span>
          </div>
          <div class="link-edit" @click="editLink">
            <span>Edit</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { processMediaURL } from '@/functions/utility.js';
import Timesince from '@/components/sidebar/Timesince.vue';

import LinkForm from '@/components/modals/links/LinkForm.vue'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LinkContainer',
  props: {
    link: Object,
    index: Number
  },
  components: {
    Timesince
  },
  data: () => ({
    show: false,
  }),
  computed: {
    ...mapGetters({ userType: 'current_user/currentAreaPermissionNo' })
  },
  methods: {
    processMediaURL,
    ...mapActions([
      'linkFrame/open',
      'api/media/library/click',
      'modal/open',
      'analytics/viewContent'
    ]),
    ...mapActions('popups/content', ['confirmRemoveLink']),
    open() {
      this['linkFrame/open'](this.link.url);
      this['api/media/library/click'](this.link.id);
      this['analytics/viewContent'](this.link)
    },
    editLink() {
      this['modal/open']([LinkForm, {data: this.link}]);
    }
  },
  mounted() {
    let loadTime = 150 + 30 * this.index;
    setTimeout(() => {
      this.show = true;
    }, loadTime);
  }
};
</script>

<style scoped lang="scss">
@import '~@/scss/components/sidebar/link_container.scss';
</style>
